import Navbar from "../components/Navbar";
import imge1 from "../assets/Newsletter-img.jpg";
import { Link, useNavigate } from "react-router-dom";
import MessageAlert from "../components/MessageAlert";
import Loader from "../components/Loader";
import useAuthStore from "../stores/authStore";
import { useEffect, useState } from "react";
import useParcelStore from "../stores/parcelStore";

const SignIn = () => {
  const setParcel = useParcelStore((state) => state.setParcel);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageID, setMessageID] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const Login = useAuthStore((state) => state.login);
  const User = useAuthStore((state) => state.user);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // -------- Redirect user if logged in -----------------
  useEffect(() => {
    if (isLoggedIn && User.role === "user") {
      navigate("/userdashboard");
    } else if (isLoggedIn && User.role === "admin") {
      navigate("/parcellist");
    }
  }, [isLoggedIn, navigate]);

  // Handle Sign Up
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`https://cargo-api.bitinverse.com/api/users/login`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message);
      }

      Login(result.user);
      if (result.user.role === "user") {
        setParcel(result.parcelList);
      }
      setMessage("Registration Successful!");
      setMessageID("successAlert");
      setShowMessage(true);
      setIsLoading(false);
    } catch (err) {
      setMessage(err.message);
      setMessageID("declineAlert");
      setShowMessage(true);

      setIsLoading(false);
    }
  };

  // Hide message after 3 seconds
  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  return (
    <>
      <Navbar />

      {showMessage ? <MessageAlert data={{ message, messageID }} /> : ""}

      <div class="container mx-auto max-w-[1200px] flex flex-wrap mt-10">
        <div
          class="w-full sm:w-1/2  p-4 bg-white authPart1"
          style={{ color: "#082D38", backgroundColor: "#a4a4a485"  }}
        >
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Login
            </h1>
            <form class="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  for="email"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="name@company.com"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label
                  for="password"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  placeholder="••••••••"
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <button
                type="submit"
                class="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                style={{ backgroundColor: "#f57539" }}
              >
                {isLoading ? <Loader /> : "Sign in"}
              </button>
              <p class="text-sm font-light text-gray-500 dark:text-gray-400">
                Don’t have an account yet? {""}
                <Link
                  to="/signup"
                  class="font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Sign up
                </Link>
              </p>
            </form>
          </div>
        </div>
        <div
          class="w-full sm:w-1/2  p-4 authPart2"
          style={{
            backgroundImage: `url("${imge1}")`,
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </div>
    </>
  );
};

export default SignIn;
